<script lang="ts">
  import FirstOrder from "@retailer/svelte/ProductLines/FirstOrderBar/FirstOrder.svelte";
  import TrackingContext from "@shared/svelte/Components/Tracking/TrackingContext.svelte";
  import { EventTracking } from "@shared/services/event_tracking/events";
  import type { RetailerType } from "@shared/types/Retailer";
  import type { RetailerUser } from "@shared/types/User";
  import { CtaEntity } from "@shared/services/event_tracking/entities";

  export let Distributors: any;
  export let user: RetailerUser;

  const { trackMrcEvents } = EventTracking;
  const trackingParams = [
    new CtaEntity({ service: "action_bar", component: "action_bar_no_orders" }),
  ];
</script>

<TrackingContext entities={trackingParams} let:trackingContext>
  <div use:trackMrcEvents={[trackingContext.entities]}>
    <FirstOrder {user} {Distributors} />
  </div>
</TrackingContext>
